import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 22h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 10h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 15v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Wine";
const Wine = memo(themed(Icon));
export {
  Wine
};
//# sourceMappingURL=wine.js.map
